import {useState} from "react";
import {requestPasswordChangeToken} from "../../services/Sysadmin/getUsers";

export const useRequestChangePassword = () => {
    const [requestChangePasswordLoading, setRequestChangePasswordLoading] = useState(false);

    const requestChangePassword = async (username: any) => {
        setRequestChangePasswordLoading(true);
        try {
            const response = await requestPasswordChangeToken(username);
            return response.data.message;
        } catch (error: any) {
            throw error;
        } finally {
            setTimeout(() => setRequestChangePasswordLoading(false), 600);
        }
    };

    return { requestChangePassword, requestChangePasswordLoading };
};